import "./DocumentManageSys.css";
import "../../styles/global.styles.css";

import React, { useEffect, useRef, useState } from "react";
import {
    createDocTypes,
    createSubTypes,
    deActivateDocument,
    documentHistory,
    getAccessibilityLevels,
    getAllAdminUsers,
    getAllDocTypes,
    getAllFiles,
    getAllSubTypes,
    getDMSDistributionList,
    publishWorkFlow,
    reviseDocument,
    updateDocTypes,
    updateSubDocTypes,
    uploadFiles,
} from "../../services/dms/dms-admin";

import ArrowIcon from "../../assets/arrow";
import { Container } from "../../styles/common.styles";
import { DataTableComponent } from "../common/TableComponent/DataTableComponent";
import HitachiTopLogo from "../../resources/topLogo";
import Loader from "../common/Loader/Loader";
import ModalComponent from "../common/ModalComponent/ModalComponent";
import { NoDataContainer } from "../../styles/common.styles";
import PendingApprovalDocument from "./PendingApprovalDocs";
import PlusIcon from "../../assets/PlusIcon";
import PlusIconRed from "../../assets/PlusIconRed";
import RenderCurrentFolder from "./RenderCurrentDocument";
import { formatDate } from "../../utils/dateFormat";
import { useTranslation } from "react-i18next";

import { getAllLanguages } from "../../services/user-services/user-level-services";
import onClickViewDoc from "./ViewDocument";
import { toast } from "react-toastify";
import { validateFileUploadFields } from "../../utils/ValidationInput";
import validateFileFormat from "../../utils/ValidationFileFormat";
import { getResolvedStatusValue } from "../../utils/statusData";
import { t } from "i18next";


let languageOptions = [
  { value: "", label: t("selectLanguage") }
];

let AccessOptions = [];

let emailOptions = [
  { value: "1", label: t("selectApprover") },
];

const DocManageSys = () => {
  const { t, i18n } = useTranslation();
  const columns = [
    { name: t("documentTitle"), field: "name", selector: (row) => row.name, sortable: true, width: "200px" },
    { name: t("uploadedDate"), field: "createdDate", selector: (row) => row.createdDate, cell: row => formatDate(row.createdDate), sortable: true, width: "150px" },
    { name: t("owner"), field: "owner", selector: (row) => row.owner, sortable: true, width: "150px" },
    { name: t("accessLevel"), field: "accessLevel", selector: (row) => row.accessLevel, sortable: true },
    { name: t("language"), field: "language", selector: (row) => row.language, sortable: true },
    { name: t("status"), field: "status", selector: (row) => getResolvedStatusValue(row), sortable: true, width: "200px" },
    { name: t("approverEmail"), field: "workFlowApproverEmail", selector: (row) => row.workFlowApproverEmail, sortable: true, width: "200px" },
    { name: t("published"), field: "isPublished", selector: (row) => row.isPublished, sortable: true },
  ];


  const modalFields = [
    {
      fieldName: t("documentTypeName"),
      type: "multiInput",
      fields: [
        { label: "(En)", name: "DocumentNameEn", fieldValue: "" },
        { label: "(Jp)", name: "DocumentNameJp", fieldValue: "" },
        { label: "(Ch)", name: "DocumentNameCh", fieldValue: "" }
      ],
      required: true
    },
  ];

const getFileUploadFields = () => [
    { fieldName: "", name: "File", fieldValue: "", type: "file" },
    { fieldName: "", name: "progress", fieldValue: "", type: "progress" },
    {
      fieldName: t("documentTitle"),
      type: "multiInput",
      fields: [
        { label: "(En)", name: "titleEn", fieldValue: "" },
        { label: "(Jp)", name: "titleJp", fieldValue: "" },
        { label: "(Ch)", name: "titleCh", fieldValue: "" }
      ],
      required: true
    },
    {
      fieldName: t("documentLanguage"),
      name: "Language",
      fieldValue: "",
      type: "dropdown",
      options: languageOptions,
      required: true
    },
    {
      fieldName: t("accessLevel"),
      name: "AccessibleTo",
      fieldValue: "",
      type: "dropdown",
      options: AccessOptions,
      required: true
    },
    { fieldName: t("owner"), name: "Owner", fieldValue: "", type: "email", required: true },
  ];

  const [fileUploadFields, setFileUploadFields] = useState(getFileUploadFields());

  const ReviseDocumentFields = [
    {
      fieldName: t("documentTitle"),
      name: "DocumentTitle",
      fieldValue: "",
      type: "",
    },
    { fieldName: "", name: "File", fieldValue: "", type: "file", showUploadIcon: true },

];
const PublishFormFields = [
    {
        fieldName: t("selectApprover"),
        name: "Emails",
        fieldValue: "",
        type: "dropdown",
        options: emailOptions,
    },
];

  const DocumentHistoryColumns = [
    { name: t("version"), field: "versionId", selector: (row) => row.versionId, sortable: true },
    { name: t("documentTitle"), field: "documentName", selector: (row) => row.documentName, sortable: true },
    { name: t("uploadedDate"), field: "createdDate", selector: (row) => row.createdDate, cell: row => formatDate(row.createdDate), sortable: true },
    { name: t("owner"), field: "owner", selector: (row) => row.owner, sortable: true },
    { name: t("comments"), field: "comments", selector: (row) => row.comments ? row.comments : t("notAvailable"), sortable: true },
  ];


    const [loading, setLoading] = useState(true);
    const [currentFolder, setCurrentFolder] = useState([]);
    const [folderName, setFolderName] = useState({
        DocumentName: "",
    });
    const [folders, setFolders] = useState([]);
    const [editMode, setEditMode] = useState({
        folder: null,
        file: null,
        newName: "",
    });
    const [tableData, setTableData] = useState([]);
    const editInputRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState("");
    const [isSubFolderClicked, setIsSubFolderClicked] = useState(false);
    const [isParentFolderClicked, setIsParentFolderClicked] = useState(true);
    const [SubFolderBtn, setSubFolderBtn] = useState(false);
    const [parentFolderData, setParentFolderData] = useState([]);
    const [subFolderData, setSubFolderData] = useState([]);
    const [fileData, setFileData] = useState([]);
    const [selectedAction, setSelectedAction] = useState(null);
    const [formData, setFormData] = useState([]);
    const [documentData, setDocumentData] = useState({});
    const [files, setFiles] = useState([]);
    const [isPendingFolderClicked, setPendingFolderClicked] = useState(false);
    const [distributionList, setDistributionList] = useState([]);
    const [payloadDistributionList, setPayloadDistributionList] = useState([]);
    const [accessibilityLevel, setAccessibilityLevel] = useState("");
    const lang = i18n.language || sessionStorage.getItem("selectedLanguage") || "en";



    useEffect(() => {
        if (editMode.folder) {
            if (editInputRef.current) {
                editInputRef.current.focus();
            }
        }
    }, [editMode]);

    useEffect(() => {
        //fetchData();
        getAdminUsers();
        fetchUserLanguages();
        fetchDistributionList();
    }, []);

    useEffect(() => {
        setFileUploadFields(getFileUploadFields());
    }, [i18n.language, languageOptions, AccessOptions]);

    useEffect(() => {
    if (isParentFolderClicked) {
        fetchData();
    } else if (isSubFolderClicked) {
        fetchAllFiles(subFolderData);
    } else {
        getAllSubDocuments(parentFolderData);
    }
}, [i18n.language, isParentFolderClicked, isSubFolderClicked, parentFolderData, subFolderData]);
    

    const getDisplayName = (item, lang) => {
        if (!item) return "";
        if (lang === "en" && item.enName) {
            return item.enName; // Use original English only when English is selected
        }
        const nameJP = item.name_JP || item.name_jp;
        const nameCH = item.name_CH || item.name_ch;
        if (lang === "jp" && nameJP && nameJP.trim().toLowerCase() !== "undefined") {
            return nameJP;
        } else if (lang === "ch" && nameCH && nameCH.trim().toLowerCase() !== "undefined") {
            return nameCH;
        } else if (item.name && item.name.trim().toLowerCase() !== "undefined") {
            return item.name;
        }
        return "";
    };

    const filterDataByLanguage = (data, lang, label) => {
        const mappedData = data
            .map(item => {
                let displayName = "";
                if (label) {
                    if (lang === "jp" && item.documentName_JP) {
                    displayName = item.documentName_JP;
                } else if (lang === "ch" && item.documentName_CH) {
                    displayName = item.documentName_CH;
                } else if (lang === "en") {
                    displayName = item.documentName;
                }
                    return {
                        ...item,
                        documentName: displayName,
                    };
                } else {
                    if (lang === "jp" && item.name_JP) {
                    displayName = item.name_JP;
                    } else if (lang === "ch" && item.name_CH) {
                        displayName = item.name_CH;
                    } else if (lang === "en") {
                        displayName = item.name;
                    }
                    return {
                        ...item,
                        name: displayName,
                        enName: item.name, // always keep original English
                        ...(item?.documentAccessibilityLevelName && { accessLevel: t(item.documentAccessibilityLevelName) }),
                    };
                }
                
            })
            // Filter out items with empty display name
            .filter(item => {
                if (label) {
                    return item.documentName && item.documentName.trim() !== "";
                } else {
                    return item.name && item.name.trim() !== "";
                }
            });
    return mappedData;
    }
    
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getAllDocTypes();
            const filteredData = await filterDataByLanguage(result.data, lang);
            setFolders(filteredData);
            setCurrentFolder(filteredData);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    const fetchDistributionList = async () => {
        try {
            setLoading(true);
            const groupResult = await getDMSDistributionList();
            const updatedData = groupResult?.data.map((item) => ({
                ...item,
                label: item.title,
                value: item.id,
            }));
            setDistributionList(updatedData);
            setFileUploadFields(fields => fields.map(f =>
                f.name === "DistributionListIds" ? { ...f, options: updatedData } : f
            ));
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const getAdminUsers = async () => {
        setLoading(true);
        const users = await getAllAdminUsers();
        if (users) {
            emailOptions = [
                { value: "", label: t("selectApprover") },
                ...users.data.map(({ userId, emailAddress }) => ({
                    value: userId,
                    label: emailAddress,
                })),
            ];
            setLoading(false);
        }
        PublishFormFields[0].options = emailOptions;
    };

    const fetchUserLanguages = async () => {
        setLoading(true);
        const langs = await getAllLanguages();
        if (langs?.data) {
            languageOptions = [
                { value: "", label: t("selectLanguage") },
                ...langs.data.map(({ languageCode, name }) => ({
                    value: languageCode,
                    label: name,
                })),
            ];
        }
        setFileUploadFields(fields => fields.map((f, idx) => idx === 3 ? { ...f, options: languageOptions } : f));
        setLoading(false);
    };

    const fetchAllFiles = async (folder) => {
        setLoading(true);
        const result = await getAllFiles({
            typeId: parentFolderData.id,
            subTypeId: subFolderData.id ? subFolderData.id : folder.id,
        });
        const filteredData = filterDataByLanguage(result?.data, lang);
        console.log("Filtered Data in fetchAllFiles:", filteredData);
        setFiles(filteredData);
        if (!filteredData) {
            setCurrentFolder([]);
            setLoading(false);
        } else {
            setTableData(filteredData);
            setCurrentFolder(filteredData);
            setLoading(false);
            return null;
        }
    };

  const getAccessibilityPermission = async () => {
    setLoading(true);
    const resp = await getAccessibilityLevels();
    if (resp) {
      AccessOptions = resp?.data?.map((item) => ({
        value: String(item.name),
        label: item.name,
      }));
      setLoading(false);
    }
    AccessOptions = [
      { value: "", label: t("selectAccess") },
      ...resp.data.map((item) => ({
        value: String(item.name),
        label: t(item.name),
      })),
    ];
    setFileUploadFields(fields => fields.map((f, idx) => idx === 4 ? { ...f, options: AccessOptions } : f));
  };

  const onChangeInput = (inputData) => {
    const { name, value } = inputData;
    setFolderName((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

    const onChangeMultiselect = (data, type) => {
        setFileData((prevData) => ({
            ...prevData,
            DistributionListIds: data,
        }));
        const selectedIds = data.map((item) => item.value);
        setPayloadDistributionList(selectedIds);
    };

    const onFileChangeInput = (inputData) => {
        if (inputData.name === "AccessibleTo") {
            if (inputData.value === "Confidential") {
            const exists = fileUploadFields.some(field => field.name === "DistributionListIds");
            if (!exists) {
                const newFields = [...fileUploadFields];
                newFields.splice(5, 0, {
                fieldName: t("selectDistributionList"),
                name: "DistributionListIds",
                type: 'multiselect',
                placeholder: t("multiselectDistributionList"),
                options: distributionList,
                required: true
                });
                setFileUploadFields(newFields);
            }
            } else {
            const index = fileUploadFields.findIndex(field => field.name === "DistributionListIds");
            if (index !== -1) {
                const newFields = [...fileUploadFields];
                newFields.splice(index, 1);
                setFileUploadFields(newFields);
            }
            }
        }
        const { name, value, files } = inputData;
        if (files && files[0]) {
            setFileData((prevData) => ({
            ...prevData,
            [name]: files[0],
            }));
        } else {
            setFileData((prevData) => ({
            ...prevData,
            [name]: value,
            }));
        }
    };

  const handleCreateFolder = async () => {
    toast.dismiss();
    if (folderName?.DocumentNameEn?.trim() && folderName?.DocumentNameJp?.trim() && folderName?.DocumentNameCh?.trim()) {
      // Required fields with types (text or email)
      const requiredFields = [
        { key: "DocumentNameEn", type: "text" },
        { key: "DocumentNameJp", type: "text" },
        { key: "DocumentNameCh", type: "text" }
      ];
    //   const isValid = validateFields(folderName, requiredFields, '', 100);
    //   if (!isValid) {
    //     setLoading(false);
    //     return;
    //   }

            const folderDetails = {
                name: folderName?.DocumentNameEn?.trim(),
                name_JP: folderName?.DocumentNameJp?.trim(),
                name_CH: folderName?.DocumentNameCh?.trim(),
                comment: folderName?.Remarks,
                isActive: true,
            };
            const createFolders = await createDocTypes(folderDetails);
            if (createFolders.data) {
                let DocName = folderDetails?.name; // default to English
                if (lang === "jp" && folderDetails?.name_JP) {
                    DocName = folderDetails.name_JP;
                } else if (lang === "ch" && folderDetails?.name_CH) {
                    DocName = folderDetails.name_CH;
                }
                toast.success(
                    t("documentCreatedSuccessfully", { documentName: DocName }),
                    { position: "top-center", theme: "dark" }
                );
                fetchData();
            }
            setFolderName({});
            setIsModalOpen(false);
        } else {
            toast.error(t("missingRequiredFieldDocumentTypeName"), {
                position: "top-center",
                theme: "dark",
            });
        }
    };

    const handleCreateSubFolder = async () => {
        setLoading(true);
        toast.dismiss();
        if (folderName?.SubDocumentNameEn?.trim() && folderName?.SubDocumentNameJp?.trim() && folderName?.SubDocumentNameCh?.trim()) {
            // Required fields with types (text or email)
            const requiredFields = [
                { key: "SubDocumentNameEn", type: "text" },
                { key: "SubDocumentNameJp", type: "text" },
                { key: "SubDocumentNameCh", type: "text" }
            ];
            // const isValid = validateFields(folderName, requiredFields, "", 100);
            // if (!isValid) {
            //     setLoading(false);
            //     return;
            // }

            const folderDetails = {
                name: folderName?.SubDocumentNameEn?.trim(),
                name_JP: folderName?.SubDocumentNameJp?.trim(),
                name_CH: folderName?.SubDocumentNameCh?.trim(),
                comment: folderName?.Remarks,
                isActive: true,
                documentTypeId: parentFolderData.id,
            };
            try {
                const createSubFolders = await createSubTypes(folderDetails, lang);
                if (createSubFolders.data) {
                    const subTypeDocs = await getAllSubTypes(
                        parentFolderData.id
                    );
                    const filteredData = filterDataByLanguage(subTypeDocs.data, lang);
                    setCurrentFolder(filteredData);
                }
                setFolderName({});
                setIsModalOpen(false);
            } catch (error) {
            } finally {
                setLoading(false);
            }
        } else {
            setLoading(false);
            toast.error(t("missingRequiredFieldDocumentSubTypeName"), {
                position: "top-center",
                theme: "dark",
            });
        }
    };

    const togglePopup = (modalType) => {
        setModalType(modalType);
        setIsModalOpen(true);
    };

     const onEditDetails = (data, selectedIndex) => {};

    const handleRightClickFolder = (event, folder) => {
        event.preventDefault();
        setEditMode({ folder: folder, file: null, newName: folder.name });
    };

    const handleEditNameChange = (event) => {
        setEditMode({ ...editMode, newName: event.target.value });
    };

    const handleSaveEdit = async (id, documentTypeId) => {
        setLoading(true);
        toast.dismiss();
        if (editMode.folder) {
            if (editMode.newName.trim() === "") {
                editMode.newName =
                    lang === "en" ? editMode.folder.name
                    : lang === "jp" ? editMode.folder.name_JP
                    : lang === "ch" ? editMode.folder.name_CH
                    : editMode.folder.name;
            }
            if (lang === "en") {
                editMode.folder.name = editMode.newName;
            } else if (lang === "jp") {
                editMode.folder.name_JP = editMode.newName;
            } else if (lang === "ch") {
                editMode.folder.name_CH = editMode.newName;
            }
        } else if (editMode.file) {
            editMode.file.name = editMode.newName;
        }
        const folderDetails = {
            id: editMode?.folder?.id,
            comment: editMode?.folder?.comment,
            isActive: true,
            ...(lang === "en" && { 
                name: editMode.newName, 
                name_JP: editMode.folder.name_JP, 
                name_CH: editMode.folder.name_CH 
            }),
            ...(lang === "jp" && { 
                name_JP: editMode.newName, 
                name: editMode.folder.enName, 
                name_CH: editMode.folder.name_CH 
            }),
            ...(lang === "ch" && { 
                name_CH: editMode.newName, 
                name: editMode.folder.enName, 
                name_JP: editMode.folder.name_JP 
            }),
        };

        if (!documentTypeId) {
            folderDetails.id = id;
            const resp = await updateDocTypes(folderDetails);
            if (resp) {
                toast.success(
                    t("documentUpdatedSuccessfully", { documentName: editMode.newName }),
                    { position: "top-center", theme: "dark" }
                );
            }
             await fetchData();
            setLoading(false);
        }
        if (documentTypeId) {
            folderDetails.id = id;
            folderDetails.documentTypeId = documentTypeId;
            const resp = await updateSubDocTypes(folderDetails);
            if (resp) {
                toast.success(
                    t("documentUpdatedSuccessfully", { documentName: editMode.newName }),
                    { position: "top-center", theme: "dark" }
                );
            }
            await getAllSubDocuments(parentFolderData);
            setLoading(false);
        }

        setEditMode({ folder: null, file: null, newName: "" });
    };

    const getAllSubDocuments = async (folder, folderList) => {
        setLoading(true);
        setIsParentFolderClicked(false);
        setSubFolderBtn(true);
        setParentFolderData(folder);
        const subTypeDocs = await getAllSubTypes(folder.id);
        const filteredData = filterDataByLanguage(subTypeDocs.data, lang);
        if (filteredData) {
            setCurrentFolder(filteredData);
            setLoading(false);
        } else {
            setCurrentFolder([]);
            setLoading(false);
        }
    };

    const getAllUploadedFiles = async (folder, folderList) => {
        setLoading(true);
        setIsSubFolderClicked(true);
        setSubFolderBtn(false);
        setSubFolderData(folder);
        await fetchAllFiles(folder);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setFormData([]);
        setDocumentData({});
        setSelectedAction(null);
        setFileData([]);
        const index = fileUploadFields.findIndex(
            (field) => field.name === "DistributionListIds"
        );
        if (index !== -1) {
            fileUploadFields.splice(index, 1);
        }
    };

    const onUploadNewDoc = async () => {
        await getAccessibilityPermission();
        setIsModalOpen(true);
        setModalType("add");
    };

    const handleFileUpload = async () => {
        toast.dismiss();
        setLoading(true);
        const formData = new FormData();

        // Validate file
        if (!fileData?.File) {
            toast.error(t("pleaseUploadFileError"), {
                position: "top-center",
                theme: "dark",
            });
            setLoading(false);
            return;
        }
        if (!validateFileFormat(fileData.File)) {
            setLoading(false);
            return;
        }
        formData.append("File", fileData.File);

        // Validate folder IDs
        if (!parentFolderData?.id) {
            toast.error(t("noDocTypeProvidedError"), {
                position: "top-center",
                theme: "dark",
            });
            setLoading(false);
            return;
        }
        formData.append("DocType", parentFolderData.id);

        if (!subFolderData?.id) {
            toast.error(t("noDocSubTypeProvidedError"), {
                position: "top-center",
                theme: "dark",
            });
            setLoading(false);
            return;
        }
        formData.append("DocSubType", subFolderData.id);
        let titleKey = "titleEn" && "titleJp" && "titleCh";
        // if (lang === "jp") titleKey = "titleJp";
        // else if (lang === "ch") titleKey = "titleCh";
        // Prepare required fields
        const requiredFields = [
        { key: titleKey, label: t("documentTitle") },
        { key: "Language", label: t("documentLanguage") },
        { key: "AccessibleTo", label: t("accessLevel") },
        { key: "Owner", label: t("owner") },
    ];
        // Validate fields
        const isValid = validateFileUploadFields(fileData, requiredFields, lang, t);
        if (!isValid) {
            setLoading(false);
            return;
        }
        // Append fields
        formData.append("AccessibleTo", fileData.AccessibleTo);
        formData.append("Language", fileData.Language);
        formData.append("Title", fileData.titleEn);
        formData.append("Title_jp", fileData.titleJp);
        formData.append("Title_ch", fileData.titleCh);
        formData.append("Owner", fileData.Owner);
        formData.append("Comment", fileData.comment);
        payloadDistributionList.forEach((item) => {
            formData.append("DistributionListIds", item);
        });

        try {
            const fileResp = await uploadFiles(formData);
            if (fileResp?.data) {
                getAllUploadedFiles(subFolderData);
                setIsModalOpen(false);
                setFileData([]);
            } else {
                toast.error(t("fileUploadApiError", { error: fileResp.error }), {
                    position: "top-center",
                    theme: "dark",
                });
                setIsModalOpen(true);
            }
        } catch (error) {
            toast.error(t("fileUploadFailedError"), {
                position: "top-center",
                theme: "dark",
            });
        } finally {
            setLoading(false);
        }
    };

    const handlePublishWithWorkflow = async (row, rowIndex, label) => {
        setDocumentData(row);
        setSelectedAction(label);
    };

    const handlePublishWithoutWorkflow = async (row, rowIndex) => {
        setLoading(true);
        setDocumentData(row);
        const resp = await publishWorkFlow(
            row?.documentMetaDataId,
            0,
            false,
            row
        );
        fetchAllFiles(subFolderData?.id);
    };

    const handleReviseDocument = (row, rowIndex, label) => {
        ReviseDocumentFields[0].fieldValue = row.name;
        setDocumentData(row);
        setSelectedAction(label);
    };

    const handleDeactivateDocument = async (row, rowIndex, label) => {
        setSelectedAction(label);
        setDocumentData(row);
    };

    const handleDocumentHistory = async (row, rowIndex, label) => {
        setAccessibilityLevel(row.documentAccessibilityLevelName);
        setLoading(true);
        const resp = await documentHistory(row);
        if (resp && resp?.data) {
            setLoading(false);
            const updatedDocumentData = resp?.data?.map((item) => ({
                ...item,
                comments: item.comments === "undefined" ? "N/A" : item.comments,
            }));
            console.log(filterDataByLanguage(updatedDocumentData, lang, label), "updatedDocumentData");
            setDocumentData(filterDataByLanguage(updatedDocumentData, lang, label));
            setSelectedAction(label);
        }
    };


  const handlePopUpSave = async (actionKey) => {
    setLoading(true);
    if (actionKey === "reviseDocument") {
      const formData = new FormData();
      formData.append("File", documentData?.file);
      if (documentData?.file !== undefined) {
        await reviseDocument(formData, documentData);
        fetchAllFiles(subFolderData?.id);
      } else {
        setLoading(false);
    toast.error(t("fileFieldRequiredError"), { position: "top-center", theme: "dark" });
        return;
      }
    } else if (actionKey === "deactivateDocument") {
      await deActivateDocument(documentData);
      fetchAllFiles(subFolderData.id);
    } else if (actionKey === "publishWithWorkflow") {
      const requiredFields = [
        { key: "value", type: "text", value: documentData?.userId },
      ];
    //   const isValid = validateFields('', requiredFields, 'byValue', 100);
    //   if (!isValid) {
    //     setLoading(false);
    //     return;
    //   }
      await publishWorkFlow(
        documentData?.documentMetaDataId,
        documentData?.userId,
        true,
        documentData
      );
      fetchAllFiles(subFolderData.id);
    }
    setSelectedAction(null);
  };

    const handleSelectedActionInputs = (inputVal) => {
        if (inputVal?.files && inputVal?.files[0]) {
            setDocumentData({ ...documentData, file: inputVal?.files[0] });
        } else {
            setDocumentData({ ...documentData, userId: inputVal.value });
        }
    };

  const getModalTitle = (actionKey) => {
    switch (actionKey) {
      case "publishWithWorkflow":
        return t("sendForApproval");
      case "reviseDocument":
        return t("reviseDocument");
      case "documentHistory":
        return t("documentHistory");
      case "deactivateDocument":
        return t("deactivateDocument");
      default:
        return "";
    }
  };

  const getFieldsData = (actionKey) => {
    switch (actionKey) {
      case "publishWithWorkflow":
        return PublishFormFields;
      case "reviseDocument":
        return ReviseDocumentFields;
      case "documentHistory":
        return null;
      case "deactivateDocument":
        return [];
      default:
        return [];
    }
  };

  const getModalType = (actionKey) => {
    switch (actionKey) {
      case "publishWithWorkflow":
        return "Add Document Sub-type";
      case "reviseDocument":
        return "Revise Document";
      case "documentHistory":
        return "Document History";
      case "deactivateDocument":
        return "DeActivate Document";
      default:
        return "";
    }
  };

  const getModalText = (actionKey) => {
    switch (actionKey) {
      case "deactivateDocument":
        return t("deactivateDocumentConfirmation");
      case "reviseDocument":
        return t("reviseDocumentConfirmation");
      case "publishWithWorkflow":
        return t("publishWithWorkflowConfirmation");
      case "publishWithoutWorkflow":
        return t("publishWithoutWorkflowConfirmation");
      case "documentHistory":
        return t("documentHistoryInfo");
      default:
        return "";
    }
  };

    const onViewIngDoc = async (row, rowIndex) => {
        onClickViewDoc(row, accessibilityLevel);
    };

    const FolderNavigation = () => {
        const navigateBack = () => {
            if (!Object.keys(parentFolderData).length > 0) {
                return null;
            }
            setIsSubFolderClicked(false);
            setSubFolderData({});
            setParentFolderData({});
            setIsParentFolderClicked(true);
            setSubFolderBtn(false);
        };

        const navigateToSubFolder = () => {
            if (!Object.keys(parentFolderData)?.length > 0) {
                return null;
            }
            getAllSubDocuments(parentFolderData);
            setIsSubFolderClicked(false);
            setSubFolderData({});
            setTableData([]);
        };

        const navigateToPendingHome = () => {
            //fetchData();
            setIsSubFolderClicked(false);
            setSubFolderData({});
            setParentFolderData({});
            setPendingFolderClicked(false);
            setIsParentFolderClicked(true);
        };

        return (
            <div>
                <h4>
                    {!isPendingFolderClicked ? (
                        <>
                            <span
                                className={`bread-crumb ${
                                    Object.keys(parentFolderData).length > 0 ||
                                    Object.keys(subFolderData).length > 0
                                        ? ""
                                        : "bread-crumb-active"
                                }`}
                                onClick={navigateBack}
                            >
                              {t("documents")}
                            </span>
                            {Object.keys(parentFolderData).length > 0 ? (
                                <span
                                    className={`bread-crumb ${
                                        Object.keys(subFolderData).length > 0
                                            ? ""
                                            : "bread-crumb-active"
                                    }`}
                                    onClick={navigateToSubFolder}
                                >
                                    <ArrowIcon />
                                    {getDisplayName(parentFolderData, lang)}
                                </span>
                            ) : (
                                ""
                            )}

                            {Object.keys(subFolderData).length > 0 && (
                                <>
                                    <ArrowIcon />
                                    <span className="bread-crumb-active">
                                    {getDisplayName(subFolderData, lang)}
                                    </span>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <span
                                className="bread-crumb"
                                onClick={navigateToPendingHome}
                            >
                                {t("documents")}
                            </span>
                            <ArrowIcon />
                            <span>{t("pendingApprovalDocuments")}</span>
                        </>
                    )}
                </h4>
            </div>
        );
    };
    return (
        <Container style={{ maxHeight: "calc(99.1vh - 2.3rem)" }}>
            <HitachiTopLogo />
            {loading && <Loader />}
            <div className="right-main-content">
                <div
                    className="folder-navigation"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    {/* Breadcrumbs */}
                    <div>{FolderNavigation()}</div>
                    {/* Right-side action buttons */}
                    <div style={{ display: "flex", gap: "1rem" }}>
                        {/* Show New Document Type on main folder view */}
                        {(isParentFolderClicked && !isPendingFolderClicked) && (
                            <button
                                className="create-folder-button secondaryButton"
                                onClick={() => togglePopup("type")}
                            >
                                <PlusIconRed /> {t("newDocumentType")}
                            </button>
                        )}
                        {SubFolderBtn && (
                            <button
                                className="create-folder-button secondaryButton"
                                onClick={() => togglePopup("subType")}
                            >
                              <PlusIconRed /> {t("newDocumentSubType")}
                            </button>
                        )}

                        {isSubFolderClicked && (
                            <button
                                className="upload-btn-div greyButton"
                                onClick={onUploadNewDoc}
                            >
                              <PlusIcon /> {t("uploadDocument")}
                            </button>
                        )}
                    </div>
                </div>

                {!isSubFolderClicked ? (
                    <div
                        className="folderContainer"
                        style={
                            currentFolder.length === 0 && isSubFolderClicked
                                ? { justifyContent: "center" }
                                : { justifyContent: "space-between" }
                        }
                    >
                        {(!isPendingFolderClicked && currentFolder.length > 0) ? (
                            <div className="folder-list col-sm-9 col-md-9 col-lg-9 col-xl-9">
                                {currentFolder.length > 0 && (
                                    <RenderCurrentFolder
                                        folderList={currentFolder}
                                        getAllUploadedFiles={getAllUploadedFiles}
                                        getAllSubDocuments={getAllSubDocuments}
                                        handleRightClickFolder={
                                            handleRightClickFolder
                                        }
                                        editMode={editMode}
                                        editInputRef={editInputRef}
                                        handleSaveEdit={handleSaveEdit}
                                        handleEditNameChange={
                                            handleEditNameChange
                                        }
                                    />
                                )}
                            </div>
                        ) : (
                            !isPendingFolderClicked &&
                            !loading &&
                            isSubFolderClicked && (
                                <NoDataContainer>
                                    <h1>{t("noDocumentsFound")}</h1>
                                </NoDataContainer>
                            )
                        )}
                        {isParentFolderClicked && (
                            <PendingApprovalDocument
                                pendingStateSender={(val) =>
                                    setPendingFolderClicked(val)
                                }
                                userId={documentData?.userId}
                                isBackClicked={isPendingFolderClicked}
                            />
                        )}
                    </div>
                ) : (
                    <div className="glbOuterWrapper">
                        <DataTableComponent
                            columns={columns}
                            data={tableData}
                            onEditDetails={onEditDetails}
                            tableName="Document"
                            handlePublishWithWorkflow={
                                handlePublishWithWorkflow
                            }
                            handlePublishWithoutWorkflow={
                                handlePublishWithoutWorkflow
                            }
                            handleReviseDocument={handleReviseDocument}
                            handleDeactivateDocument={handleDeactivateDocument}
                            handleDocumentHistory={handleDocumentHistory}
                            pageCount={5}
                        />
                    </div>
                )}

                {/* Modals */}
                {isModalOpen && !isSubFolderClicked && (
                    <ModalComponent
                        modalTitle={
                            modalType === "type"
                                ? t("addDocumentType")
                                : t("addDocumentSubtype")
                        }
                        isOpen={isModalOpen}
                        fieldsData={
                            modalType === "type"
                                ? modalFields
                                : [
                                      {
                                          fieldName: t("documentSubTypeName"),
                                          type: "multiInput",
                                          fields: [
                                            { label: "(En)", name: "SubDocumentNameEn", fieldValue: "" },
                                            { label: "(Jp)", name: "SubDocumentNameJp", fieldValue: "" },
                                            { label: "(Ch)", name: "SubDocumentNameCh", fieldValue: "" }
                                          ],
                                          required: true,
                                      },
                                      { ...modalFields[1] },
                                  ]
                        }
                        dropdownOptions={""}
                        formData={""}
                        modalType={
                            modalType === "type"
                                ? t("addDocumentType")
                                : t("addDocumentSub-type")
                        }
                        onClose={closeModal}
                        onChangeInput={onChangeInput}
                        buttons={[
                            <button
                                className="saveButton"
                                onClick={
                                    modalType === "type"
                                        ? handleCreateFolder
                                        : handleCreateSubFolder
                                }
                            >
                                {t("add")}
                            </button>,
                            <button
                                className="cancelButton"
                                onClick={closeModal}
                            >
                                {t("cancel")}
                            </button>,
                        ]}
                    />
                )}
                {isSubFolderClicked && (
                    <ModalComponent
                        modalTitle={t("uploadDocument")}
                        isOpen={isModalOpen}
                        fieldsData={fileUploadFields}
                        dropdownOptions={languageOptions}
                        formData={formData}
                        modalType={t("addDocumentSub-type")}
                        onClose={closeModal}
                        onChangeInput={onFileChangeInput}
                        onChangeMultiselect={onChangeMultiselect}
                        buttons={[
                            <button
                                className="saveButton"
                                onClick={handleFileUpload}
                            >
                                {t("submit")}
                            </button>,
                            <button
                                className="cancelButton"
                                onClick={closeModal}
                            >
                              {t("cancel")}
                            </button>,
                        ]}
                    />
                )}
                {selectedAction && (
                    <ModalComponent
                        modalTitle={
                            selectedAction ? getModalTitle(selectedAction) : ""
                        }
                        isOpen={selectedAction}
                        fieldsData={
                            selectedAction !== "documentHistory"
                                ? getFieldsData(selectedAction)
                                : []
                        }
                        dropdownOptions={languageOptions}
                        formData={selectedAction === "documentHistory" ? documentData : []}
                        modalText={getModalText(selectedAction)}
                        modalType={selectedAction ? getModalType(selectedAction) : ""}
                        onClose={closeModal}
                        onChangeInput={handleSelectedActionInputs}
                        onViewDoc={onViewIngDoc}
                        columns={DocumentHistoryColumns}
                        buttons={
                            selectedAction !== "documentHistory"
                                ? [
                                      <button
                                          className="saveButton"
                                          onClick={() => {
                                              handlePopUpSave(selectedAction);
                                          }}
                                      >
                                          {t("submit")}
                                      </button>,
                                      <button
                                          className="cancelButton"
                                          onClick={closeModal}
                                      >
                                          {t("cancel")}
                                      </button>,
                                  ]
                                : [
                                      <button
                                          className="cancelButton"
                                          onClick={closeModal}
                                      >
                                           {t("close")}
                                      </button>,
                                  ]
                        }
                    />
                )}
            </div>
        </Container>
    );
};

export default DocManageSys;
